import React from 'react';
import Navbar from './Navbar';
import './Layout.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <footer className="footer">
        <div className="container">
          <p>© 2025 DanHunt</p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
